import { render, staticRenderFns } from "./selectLinkmanComponent.vue?vue&type=template&id=2822d14a&scoped=true&"
import script from "./selectLinkmanComponent.vue?vue&type=script&lang=js&"
export * from "./selectLinkmanComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2822d14a",
  null
  
)

export default component.exports